<template>
	<page-container :page="page" :locale="locale">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content :title="page.title || page.header" :content="page.content" />

		<section class="main-content contact-section background-light">
			<div class="row contact-form-row">
				<div class="columns column5 contact-form-col">
					<contact-form name="meeting" :form="form" />
				</div>
			</div>
		</section>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

const { data: form } = await useWebsiteFetch('meeting', {
	query: { language: locale.value },
	key: `${locale.value}/meeting`,
});
</script>

<style scoped lang="scss">
.contact-form-col {
	margin: auto;
}

@media (max-width: 900px) {
	.contact-section {
		padding-top: 0;
	}

	.main-content#intro {
		padding-bottom: 15px;
	}
}
</style>
